import React, { useState } from "react";
import { Menu, MenuItem, Button, Box } from "@mui/material";
import { useTranslation, Trans } from "react-i18next";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SortIcon from "@mui/icons-material/Sort";
import "@styles/components/ui/DropdownFilterMenu.scss";
const DropdownFilterMenu = ({
  options,
  displayField,
  valueField = "",
  defaultIndex = 0,
  lang,
  defaultFirstLabel,
  icon = "expand",
  value, // ⭐️ 外面傳入既 value
  onChange = () => {},
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);

  // ⭐️ 依家 selected 根據外面傳入的 value
  const selected =
    options.find((item) => item[valueField] === value) ||
    options[defaultIndex] ||
    {};

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (item) => {
    onChange(item); // 外面 update value
    handleClose();
  };

  const buttonIcon = () => {
    if (icon == "expand") return <ExpandMoreIcon />;
    if (icon == "sort") return <SortIcon />;
  };
  return (
    <Box>
      <Button
        
        disableElevation
        disableRipple
        onClick={handleClick}
        endIcon={buttonIcon()}
        className={`dropdown-button ${open ? "open" : ""}`}
      >
        {itemLabel(selected, displayField, lang)}
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        className="dropdown-menu"
        TransitionComponent={null}
      >
        {options.map((item, index) => (
          <MenuItem
            key={index}
            onClick={() => handleSelect(item)}
            selected={selected[valueField] === item[valueField]}
          >
            {itemLabel(item, displayField, lang)}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

// Helper to handle multi-language display
const itemLabel = (item, displayField, lang) => {
  if (!item) return "";
  if (typeof displayField === "function") {
    return displayField(item);
  }
  return item?.[`${displayField}_${lang}`] || item?.[displayField] || "";
};

export default DropdownFilterMenu;
